exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centerizebtn button[data-v-f78bf6da] {\n  min-height: 0px;\n  color: red;\n}", ""]);

// exports
